export enum PayUnit {
  Dollars = 0,
  MileageRate = 1,
  Miles = 2,
  PercentageGrossNetFuel = 3,
  PercentageGross = 4,
  PercentageGrossNetFuelNoDH = 5,
  PercentageGrossNoDH = 6
}

export const PayUnitMapping: Record<PayUnit, string> = {
  [PayUnit.Dollars]: 'Dollars',
  [PayUnit.MileageRate]: 'Mileage Rate',
  [PayUnit.Miles]: 'Miles',
  [PayUnit.PercentageGrossNetFuel]: '% Gross Net Fuel',
  [PayUnit.PercentageGross]: '% Gross',
  [PayUnit.PercentageGrossNetFuelNoDH]: '% Gross Net Fuel No DH',
  [PayUnit.PercentageGrossNoDH]: '% Gross No DH'
};

export const PayUnitSuffixMapping: Record<PayUnit, string> = {
  [PayUnit.Dollars]: '',
  [PayUnit.MileageRate]: '',
  [PayUnit.Miles]: '',
  [PayUnit.PercentageGrossNetFuel]: 'Gross Net Fuel',
  [PayUnit.PercentageGross]: 'Gross',
  [PayUnit.PercentageGrossNetFuelNoDH]: 'Gross Net Fuel No DH',
  [PayUnit.PercentageGrossNoDH]: 'Gross No DH'
};
